module.exports = __webpack_public_path__ + "img/561ffa09bbd8f52c370128d7d4f6461f.png";